var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[(_vm.$regConfig.reg_cover)?_c('img',{attrs:{"src":_vm.$regConfig.reg_cover}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }